<template>
  <div>
    <main class="py-4">
      <navbar v-if="user.loggedIn"></navbar>
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
import navbar from "./components/Navbar";
import firebase from 'firebase';
import { mapGetters } from "vuex";

export default {
  components: {
    navbar
  },
  computed: {
    ...mapGetters({
// map `this.user` to `this.$store.getters.user`
      user: "user"
    })
  },
  date(){
    return {
      currentUser: firebase.auth().currentUser
    }
  }
};
</script>